import classNames from "classnames";
import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { useIdCopy } from "@hooks/useIdCopy";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { HStack } from "@design-system/HStack/HStack";
import { CategoryIcon } from "@components/transactions/CategoryIcon";
import { TransactionCategoryRow } from "../viewUtils";
import styles from "../Categories.module.scss";

export const NameCell = memo(function NameCell({
    row,
}: CellContext<ViewTableFeatures, TransactionCategoryRow, unknown>) {
    const item = row.original;

    const { getCopyProps } = useIdCopy({
        label: item.parentId ? "Subcategory" : "Category",
    });

    return (
        <ViewTableCell>
            <HStack
                align="center"
                className={classNames(
                    styles.categoryIdCell,
                    item.parentId && styles.categoryIdCellSubCategory,
                )}
            >
                {item.parentId ? (
                    <div
                        className={classNames(styles.rowIcon, styles.childIcon)}
                    >
                        <div className={styles.verticalLine} />
                    </div>
                ) : (
                    <CategoryIcon categoryId={item.id} />
                )}

                <span
                    className={classNames(styles.categoryLabel, {
                        [styles.categoryLabelCollapsible]: !item.parentId,
                    })}
                    {...getCopyProps(item.id)}
                >
                    {item.label}
                </span>
            </HStack>
        </ViewTableCell>
    );
});
